import React from 'react';
import { connect } from 'react-redux';
import { firstError } from '@/utils/errors';
import findResult from '@/utils/resultsHelper';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { showShareSearch } from '../actions';

const ShareSearchAction = ({
  category,
  code,
  readErrors,
  share,
  secureOnly,
}) => (
  <RibbonMenu
    name="share"
    icon={secureOnly ? 'shield' : 'share alternate'}
    message={secureOnly ? 'actions.security' : 'actions.share'}
    onClick={() => share(category, code)}
    className="aridhia-share-search-action"
    disabled={firstError(readErrors) !== null}
  />
);

const mapStateToProps = ({
  search: { searches },
}, { category, code }) => {
  const search = findResult(searches, category, code);
  return { readErrors: search ? search.readErrors : [] };
};

const mapDispatchToProps = {
  share: showShareSearch,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareSearchAction);
